module.exports = __webpack_public_path__ + "img/icon-marker-accent-0.82f33633.svg";